<template>
  <div
    role="dialog"
    aria-labelledby="ready-title"
    aria-describedby="ready-desc"
    @click="handleClick"
    :class="{
      popup: true,
      opened: isOpen,
    }"
  >
    <div class="popup-window" ref="dialog">
      <h1 id="ready-title" v-t="'preview.getUpTitle'" />
      <p id="ready-desc" v-t="'preview.almostReady'" />
      <base-button v-t="'preview.watchPreview'" ref="button" small />
    </div>
  </div>
</template>

<script>
import store from '@/store';

export default {
  model: {
    prop: 'isOpen',
    event: 'setState',
  },
  props: {
    isOpen: Boolean,
  },
  methods: {
    handleClick(event) {
      const button = this.$refs.button.$el;
      const dialog = this.$refs.dialog;

      const isButtonClick = button.contains(event.target);
      const isDialogClick = dialog.contains(event.target);

      if (isButtonClick || !isDialogClick) {
        this.$emit('setState', false);
      }

      this.rnAppMetricaReportEvent('preview', store.appMetricaData);
    },
  },
};
</script>

<style scoped src="./sitePreviewPopup.css"></style>
